import useSWR from 'swr';
import { nulllist } from 'util/ssqutil';
/*

## 요청URL

- http://10.110.50.10:6501/NEWLS/api/popQuery.jsp?type=


## 요청변수

| 요청변수 | 설명(Desc)      | default | value  | 비고                                |
| -------- | --------------- | ------- | ------ | ----------------------------------- |
| type     | 인기검색어 타입 | PWW     | String | 월별 : PWM, 주별 : PWW , 일별 : PWD |


## API 결과 

| API 결과 필드 설명 | Data Type | 설명                                  |
| ------------------ | --------- | ------------------------------------- |
| serviceDate        | String    | 인기검색어 생성날짜 시간              |
| isOk               | boolean   | true : 성공, false : 실패             |
| type               | String    | 월별 : PWM,주별 : PWW,일별 : PWD      |
| result             | Array     | 결과 배열                             |
| - popwordHistoryNo | String    | id값                                  |
| - service          | String    | 관리도구 Label 아이디                 |
| - num              | int       | 인기 순위                             |
| - cnt              | int       | 누적건수                              |
| - wordUnq          | String    | 인기검색어                            |
| - word             | String    | 인기검색어                            |
| - rnk              | Sriring   | 상승폭 ( 1000 신규, 나머지는 상승폭 ) |


## 예시 

```
예시 ) http://10.110.50.10:6501/NEWLS/api/popQuery.jsp?type=PWW&pretty=y

{
  ""result"": [
    {
      ""popwordHistoryNo"": ""PWW_@ALL_20260719_1_20260719000249548"",
      ""service"": ""@ALL"",
      ""num"": 1,
      ""cnt"": 1047,
      ""wordUnq"": ""xg5000"",
      ""pubDate"": 20260719,
      ""word"": ""xg5000"",
      ""rnk"": 0
    }
  ],
  ""serviceDate"": ""20260719000249548"",
  ""isOk"": true,
  ""count"": 10,
  ""error"": """",
  ""type"": ""PWW""
}
```
*/

export interface IfSrchV3PopQueryRow {
  wordUnq: string;
  word: string;
}

interface IfSrchV3PopQueryRes {
  result: IfSrchV3PopQueryRow[];
  isOk: boolean;
  count: number;
}

export const useApiSrchV3PopQuery = (show: boolean) => {
  const { data, isLoading, error } = useSWR<IfSrchV3PopQueryRes>(
    show && ['/api/guest/srch/v3/popQuery', { type: 'PWW' }]
  );
  return {
    list: data?.result ?? nulllist,
    isLoading,
    error,
  };
};
